import { MenuStudentRepository } from '@/components/infrastructure/repository/menu_student_repository'
import { GetAllMenuStudentUseCase } from '../usercase/menu_student_case'
import { AppService } from '@/core/http/http-client'

class MenuStudentService {
  private menuAdapter: MenuStudentRepository
  private getAllMenuCase: GetAllMenuStudentUseCase

  constructor() {
    const http = new AppService()
    this.menuAdapter = new MenuStudentRepository(http)
    this.getAllMenuCase = new GetAllMenuStudentUseCase(this.menuAdapter)
  }

  async getAllMenu(idUser: number) {
    return await this.getAllMenuCase.execute(idUser)
  }
}

export const menuService = new MenuStudentService()
